import { render } from "./AsMenuContacts.vue?vue&type=template&id=1756f6f0&ts=true"
import script from "./AsMenuContacts.vue?vue&type=script&lang=ts"
export * from "./AsMenuContacts.vue?vue&type=script&lang=ts"

import "./AsMenuContacts.vue?vue&type=style&index=0&id=1756f6f0&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__